<template>
  <div>
    <h2>Listagem Movimentações de Ativos</h2>

    <v-data-table
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="data.length"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                  v-model="searchFilter.query"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                  clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                  v-model="searchFilter.email"
                  append-icon="mdi-magnify"
                  label="E-mail"
                  single-line
                  hide-details
                  clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                  v-model="searchFilter.document"
                  append-icon="mdi-magnify"
                  label="CPF"
                  v-mask="'###.###.###-##'"
                  single-line
                  hide-details
                  clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total > 0"
            >Exibindo {{ from }} - {{ to }} de {{ total }}
          </span>
        </div>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="totalPages"></v-pagination>
    </div>
  </div>
</template>


<script>
import { mapMutations } from 'vuex';
import Api from '../../services/api.service';

export default {
  name: 'Users',
  data: () => ({
    data: [],
    headers: [
      { text: 'Data Transação', value: 'data_transacao' },
      { text: 'Hora Transação', value: 'hora_transacao' },
      { text: 'Usuário', value: 'usuario' },
      { text: 'Tipo', value: 'type' },
      { text: 'Status', value: 'status' },
      { text: 'Moeda/Token', value: 'name_token' },
      { text: 'Qtde Transacionada', value: 'qtde_transacionada' },
      { text: 'Valor Transacionado', value: 'valor_transacionada' },
      { text: 'Taxas', value: 'taxas' },
    ],
    isLoading: true,
    page: 1,
    page_atual: 1,
    perPage: 8,
    searchFilter: {
      query: null,
      email: null,
      document: null
    },
    sortBy: 'id',
    to: 0,
    total: 0,
    totalPages: 0,
  }),
  filters: {
    formatList(list) {
      return list.map(e => e.name).sort().join(', ') 
    }
  },
  watch: {
    page: function () {
      if(this.page != this.page_atual)
      this.loadData();
    },
    searchFilter: {
      handler () {
        this.page = 1;
        this.loadData();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),


    loadData () {
      this.isLoading = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        sort: this.sortBy,
      };

      if (this.searchFilter.query)
        params['filter[nameOrEmail]'] = this.searchFilter.query;

      if(this.searchFilter.email)
        params['filter[nameOrEmail]'] = this.searchFilter.email;

      if (this.searchFilter.document)
        params['filter[nameOrEmail]'] = this.searchFilter.document.replace(/[^0-9]/gi, '');

      Api.get('movimentActivesList', {params}).then(({ data }) => {
          const { from, to, total, data: items, current_page } = data;
          this.data = items.data;
          this.page_atual = current_page;
          this.from = from;
          this.to = to;
          this.total = total;
          this.totalPages = Math.ceil(this.total/this.perPage);

        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));


    },
  },
}
</script>
